import { render, staticRenderFns } from "./screenNotificacion.vue?vue&type=template&id=78d477ac&scoped=true"
import script from "./screenNotificacion.vue?vue&type=script&lang=js"
export * from "./screenNotificacion.vue?vue&type=script&lang=js"
import style0 from "./screenNotificacion.vue?vue&type=style&index=0&id=78d477ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d477ac",
  null
  
)

export default component.exports